import { PeriodoAprovacaoFatura, SituacaoFatura } from '../../components/types';
import { BaseResourceModel } from '../../models/base-resource.model';
import { Favorecido } from '../compra/favorecido.model';
import { Exercicio } from '../comum/exercicio.model';
import { Orgao } from '../comum/orgao.model';
import { FaturaHistorico } from './fatura-historico.model';
import { FaturaStorage } from './fatura-storage.model';
import { FaturaTipoImovel } from './fatura-tipo-imovel.model';
import { LiquidacaoFaturaTipo } from './liquidacao-fatura-tipo.model';
import { LiquidacaoRestoFaturaTipo } from './liquidacao-resto-fatura-tipo.model';

export class Fatura extends BaseResourceModel {
  constructor(
    public codigo_barra?: string,
    public vencimento?: Date,
    public competencia?: Date,
    public medicao?: number,
    public valor_fatura?: number,
    public valor_IR1?: number,
    public valor_IR2?: number,
    public base_ir1?: number,
    public base_ir2?: number,
    public taxa?: number,
    public juros?: number,
    public att_monetaria?: number,
    public justificativa?: string,
    public situacao?: SituacaoFatura,
    public periodo_aprovacao?: PeriodoAprovacaoFatura,
    public fatura_tipo_imovel?: FaturaTipoImovel,
    public favorecido?: Favorecido,
    public arquivos?: FaturaStorage[],
    public historico?: FaturaHistorico[],
    public liquidacoes_fatura?: LiquidacaoFaturaTipo[],
    public liquidacoes_resto_fatura?: LiquidacaoRestoFaturaTipo[],
    public exercicio?: Exercicio,
    public orgao?: Orgao
  ) {
    super();
  }

  static converteJson(json: any): Fatura {
    return Object.assign(new Fatura(), json);
  }
}
